module.exports = __webpack_public_path__ + "static/map_pudong_new-630ace1522c4e7096011a8e0e4945df8.jpg";